import { motion } from 'framer-motion';

const testimonials = [
  {
    name: 'Sarah Johnson',
    username: 'sarahj',
    avatar: 'bg-mint',
    text: 'Working with this loan officer made our first home purchase so much easier. The process was smooth, and we got a great rate. Highly recommend!',
    verified: true,
  },
  {
    name: 'Michael Chen',
    username: 'mchen',
    avatar: 'bg-peach',
    text: 'Refinanced our mortgage and saved over $300 a month. The expertise and attention to detail were outstanding. Thank you for making this happen!',
    verified: true,
  },
  {
    name: 'Emily Rodriguez',
    username: 'erodriguez',
    avatar: 'bg-blue-100',
    text: 'As a first-time buyer, I had so many questions. Every single one was answered with patience and clarity. The pre-approval came through in less than 24 hours!',
    verified: true,
  },
  {
    name: 'David Thompson',
    username: 'dthompson',
    avatar: 'bg-lavender',
    text: 'Best mortgage experience I have ever had. Professional, responsive, and truly cared about getting us the best deal possible. Will definitely work together again.',
    verified: true,
  },
  {
    name: 'Jessica Martinez',
    username: 'jmartinez',
    avatar: 'bg-yellow-100',
    text: 'The local market knowledge was invaluable. Helped us navigate a competitive market and secure financing for our dream home. Forever grateful!',
    verified: true,
  },
  {
    name: 'Robert Williams',
    username: 'rwilliams',
    avatar: 'bg-pink-100',
    text: 'Exceptional service from start to finish. The rate matching promise was honored, and we closed on time. This is how mortgage lending should be done.',
    verified: true,
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block mb-6 px-4 py-2 rounded-full border-2 border-teal"
          >
            <span className="text-teal text-sm font-semibold">Client Success Stories</span>
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-5xl md:text-6xl font-bold text-gray-900 mb-4"
          >
            Real People, Real Results
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-2xl text-gray-600"
          >
            Helping Families Achieve Homeownership
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className={`w-12 h-12 rounded-full ${testimonial.avatar} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-xl font-bold text-gray-700">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h4 className="font-bold text-gray-900 text-lg truncate">{testimonial.name}</h4>
                    {testimonial.verified && (
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-verified-badge-fill text-sm text-teal"></i>
                      </div>
                    )}
                  </div>
                  <p className="text-sm text-gray-500 truncate">@{testimonial.username}</p>
                </div>
              </div>
              
              <p className="text-gray-700 leading-relaxed">
                <span className="text-gray-400 text-2xl leading-none">"</span>
                {testimonial.text}
                <span className="text-gray-400 text-2xl leading-none">"</span>
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}